<template>
  <div v-if="member">
    <v-list two-line subheader>
      <v-subheader class="display-1">{{ member.member.first_name }} {{ member.member.last_name }}</v-subheader>
      <v-subheader class="title">{{ member.company.name }}</v-subheader>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Sector</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.member.sector">{{ member.member.sector }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Email</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.member.email">{{ member.member.email }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :href="`mailto:${member.member.email}`" target="_blank" icon title="Email"
                 :disabled="!member.member.email">
            <v-icon>email</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Direct Dial</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.member.direct_dial">{{ member.member.direct_dial }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :href="`tel:${member.member.direct_dial}`" target="_blank" icon
                 title="Direct Dial" :disabled="!member.member.direct_dial">
            <v-icon>phone</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Mobile</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.member.mobile">{{ member.member.mobile }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :href="`tel:${member.member.mobile}`" target="_blank" icon title="Mobile"
                 :disabled="!member.member.mobile">
            <v-icon>smartphone</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-list three-line subheader>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Address</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.address">
            {{ this.formattedAddress1(member.address) }}
          </v-list-tile-sub-title>
          <v-list-tile-sub-title v-if="member.address">
            {{ this.formattedAddress2(member.address) }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :href="this.googleMapUrl(member.address)" target="_blank" icon
                 title="Google Maps" :disabled="!member.address.post_code">
            <v-icon>location_city</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-list two-line subheader>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Main Phone</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.address.telephone">{{ member.address.telephone }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn :href="`tel:${member.address.telephone}`" target="_blank" icon title="Main Phone"
                 :disabled="!member.address.telephone">
            <v-icon>phone</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Fax</v-list-tile-title>
          <v-list-tile-sub-title v-if="member.address.fax">{{ member.address.fax }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Member',
  props: {
    member: Object
  },
  methods: {
    ...mapActions('application', { setTitle: 'setTitle' }
    ),
    back () {
      this.$router.go(-1)
    },
    formattedAddress1 (address) {
      let elements = []
      elements.push(address.address1)
      elements.push(address.address2)
      elements.push(address.address3)
      return elements.filter(e => e).join(', ')
    },
    formattedAddress2 (address) {
      let elements = []
      elements.push(address.town)
      elements.push(address.county)
      elements.push(address.post_code)
      return elements.filter(e => e).join(', ')
    },
    googleMapUrl (address) {
      if (address.post_code) {
        return `https://www.google.co.uk/maps/search/${address.post_code.replace(' ', '+')}`
      }
      return null
    }
  }
}
</script>

<style scoped>

</style>
